
/**
 * 权限列表中的类型，1：角色 2：权限
 */
export const AuthItemType = {
  'Role': 1,
  'Permission': 2
}
